export default function AppFooter() {
  return (
    <footer className="w-full bg-primary-900 border-t border-primary-100 h-16 flex items-center justify-center">
      <div className="container mx-auto px-4 text-center text-sm text-primary-50">
        &copy; {new Date().getFullYear()} NClood. All rights reserved.
      </div>
    </footer>
  );
}